app.service('router', ['$rootScope', function ($rootScope) {
    this.init = function () {
        $.router.init();
    };

    this.subscribe = function (url, callback) {
        $.route(url, function (data, params, query) {
            var phase = $rootScope.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                callback(data, params, query);
            } else {
                $rootScope.$apply(function () {
                    callback(data, params, query)
                });
            }
        });
    };

    this.navigate = function (url) {
        $.router.set(url);
    };
}]);

app.directive('ngNavigate', ['router', function (router) {
    return {
        restrict: "A",
        scope: {
            isRouterNavigate: "=ngNavigate"
        },
        link: function ($scope, element, attrs) {
            element.on('click', function (e) {
                if ($scope.isRouterNavigate === false) {
                    return true;
                }
                let url = element.attr('href');
                if (url.includes('#')) {
                    e.preventDefault();
                    return false;
                }
                router.navigate(url);
                e.preventDefault();
            });
        }
    };
}]);

app.directive('ngPaginator', [function () {
    return {
        restrict: "A",
        scope: {
            paginator: "=ngPaginator",
            initCount: "@"
        },
        template: '' +
            '<li ng-if="arrows.left" ng-class="{disabled:arrows.left.disabled}"><a href="{{arrows.left.url}}" ng-navigate=""><i class="icon-left"></i></a></li>' +
            '<li ng-repeat="page in pages"  ng-class="{active:page.current}">' +
            '<a ng-if="!page.skip" href="{{page.url}}" ng-navigate="">{{page.index}}</a><span ng-if="page.skip">...</span></li>' +
            '<li ng-if="arrows.right" ng-class="{disabled:arrows.right.disabled}"><a href="{{arrows.right.url}}" ng-navigate=""><i class="icon-right"></i></a></li>',
        link: function ($scope, element, attrs) {
            if ($scope.initCount) {
                $scope.paginator.count = parseInt($scope.initCount);
            }

            $scope.$watch('[paginator.current, paginator.count]', function (value) {
                $scope.pages = getPages($scope.paginator);
                $scope.arrows = getArrows($scope.pages, $scope.paginator)
            });

            function getUrl(index) {
                let url = $scope.paginator.url;
                return (index > 1) ? (url + (url.indexOf('?') > 0 ? '&p=' : '?p=') + index) : url;
            }

            function getPages(paginator) {
                let pages = [];
                let pagesCount = Math.floor((paginator.count - 1) / paginator.size) + 1;
                for (let i = 1; i <= pagesCount; i++) {
                    if ((i <= paginator.current + 1 & i >= paginator.current - 1) || i === 1 || i === pagesCount) {
                        let page = {index: i, current: i === paginator.current, url: getUrl(i)};
                        pages.push(page);
                    } else if (i === 2 || i === pagesCount - 1) {
                        pages.push({index: i, skip: true});
                    }
                }
                return pages;
            }

            function getArrows(pages, paginator) {
                if (pages.length) {
                    let left = {disabled: pages[0].current, url: '#'};
                    let right = {disabled: pages[pages.length - 1].current, url: '#'};
                    if (!left.disabled) left.url = getUrl(paginator.current - 1);
                    if (!right.disabled) right.url = getUrl(paginator.current + 1);
                    return {
                        left: left,
                        right: right
                    }
                }
                return {}
            }
        }
    };
}]);

app.directive('ngProjects', [function () {
    return {
        restrict: "A",
        templateUrl: 'projects-tpl'
    };
}]);

app.service('projectsFilterService', ['$q', 'geoService', 'LANG', 'FILTER_DATA', function ($q, geoService, LANG, FILTER_DATA) {
    let self = this;

    let PROJECTS_URL_PATTERN = /\/([^\/?]+)s(?:\/(.+?))?\/?$/;
    let RANGE_PATTERN = /(min|[\d]+)-(max|[\d]+)/;
    let TYPES = FILTER_DATA.TYPES;
    if (FILTER_DATA.CURRENT_GEO) {
        geoService.addCacheGeo(FILTER_DATA.CURRENT_GEO);
    }
    (FILTER_DATA.GEOS || []).forEach(function (node) {
        geoService.addCacheGeo(node);
    });

    self.routeDataToFilter = function (data, query) {
        let match = PROJECTS_URL_PATTERN.exec(data.route.split('?')[0]);
        if (!match) return $q.resolve(null);
        let pj_type = self._findItem(TYPES, 'slug', match[1]);
        if (!pj_type && match[1] !== 'project') return $q.resolve(null);
        let geoPath = match[2] || null;
        let geoRequest = geoPath
            ? geoService.getGeoByPath(geoPath)
            : $q.resolve({success: true, geo_node: null});

        return geoRequest.then(function (result) {
            if (!result.success) return null;
            let geoNode = result.geo_node;
            let filter = {
                'is_active': true,
                'is_approve': true,
                'id': query['project_id'] ? query['project_id'] : null,
                'type_id': pj_type ? pj_type.id : null,
                'geo_node_id': geoNode ? geoNode.id : null,
                'order_by': query['order_by'] ? query['order_by'] : '-score__total'
            };

            if (filter.is_sale) {
                self._updateRangeValues('sale_price', filter, query);
            }

            if (filter.is_rent) {
                self._updateRangeValues('rent_price', filter, query);
            }

            return filter
        });
    };

    self.filterToUrl = function (filter) {
        let pj_type = self._findItem(TYPES, 'id', filter.type_id);
        let geoNode = filter.geo_node_id ? geoService.findGeoById(filter.geo_node_id) : null;
        if (filter.geo_node_id && !geoNode) {
            throw new Error('Unknown GeoNode #' + filter.geo_node_id);
        }

        let url = LANG.path + '/' + (pj_type ? pj_type.slug : 'project') + 's/';
        url += geoNode ? geoNode.path + '/' : "";

        if (filter.id) {
            url = self._appendUrlParam(url, 'project_id', filter.id)
        }

        if (filter.is_sale) {
            url = self._setRangeValuesToUrl(url, 'sale_price', filter);
        }

        if (filter.is_rent) {
            url = self._setRangeValuesToUrl(url, 'rent_price', filter);
        }

        if (filter.order_by) {
            url = self._appendUrlParam(url, 'order_by', filter.order_by)
        }

        return url;
    };

    self._findItem = function (items, key, value) {
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (item[key] === value) return item;
        }
        return null;
    };

    self._updateMultipleValues = function (key, options, data, extract) {
        if (data[key] !== undefined) {
            let multiple_str = data[key].toString();
            let multiple_values = multiple_str.split('-');
            let values = [];
            for (let i in multiple_values) {
                let value = multiple_values[i];
                if (extract) {
                    extract(values, value);
                } else {
                    values.push(value)
                }
            }
            options[key] = values
        }
    };

    self._updateRangeValues = function (key, options, data) {
        if (data[key]) {
            let optionsStr = data[key];
            let match = RANGE_PATTERN.exec(optionsStr);
            if (match) {
                options[key] = [match[1] !== 'min' ? match[1] : null, match[2] !== 'max' ? match[2] : null];
            }
        }
    };

    self._extractBedNumber = function (values, value) {
        if (BEDS[value] !== undefined) {
            values.push(BEDS[value])
        }
    };

    self._setMultipleValuesToUrl = function (url, key, options) {
        if (options[key] && options[key].length > 0) {
            let value = "";
            let values = options[key].sort(function (a, b) {
                return a - b;
            });
            for (let i in values) {
                value += values[i] + '-'
            }
            return self._appendUrlParam(url, key, value.substr(0, value.length - 1))
        }
        return url;
    };

    self._setRangeValuesToUrl = function (url, key, options) {
        let range = options[key];
        if (range && range.length === 2 && (range[0] != null || range[1] != null)) {
            let value = (range[0] != null ? range[0] : 'min') + '-' + (range[1] != null ? range[1] : 'max');
            return self._appendUrlParam(url, key, value)
        }
        return url;
    };

    self._appendUrlParam = function (base, key, value) {
        let sep = (base.indexOf('?') > -1) ? '&' : '?';
        return base + sep + key + '=' + value;
    };
}]);

app.controller('projectsController', ['$rootScope', '$scope', '$controller', '$document', 'router', 'projectService', 'geoService', 'projectsFilterService', 'TRANS', 'FILTER_DATA', function ($rootScope, $scope, $controller, $document, router, projectService, geoService, projectsFilterService, TRANS, FILTER_DATA) {
    //controller inheritance from appController
    $controller('appController', {$scope: $scope});

    $scope.FILTER_DATA = FILTER_DATA;

    $scope.filter = null;
    $scope.isFilterUpdated = false;
    $scope.isFilterActive = false;

    $scope.projects = null;

    $scope.isInitialState = true;
    $scope.displayProjectsHtml = true;

    $scope.paginator = {
        count: 0,
        current: 1,
        size: 12,
        url: null,
    };

    $rootScope.page = {};

    $scope.projectSlide = {activeId: null};

    $scope.openFilter = function () {
        $scope.isFilterActive = true;
    };

    $scope.closeFilter = function () {
        $scope.isFilterActive = false;
    };

    $scope.filterSelectAction = function (is_sale, is_rent) {
        if ($scope.filter.is_sale === is_sale && $scope.filter.is_rent === is_rent) return;
        $scope.filter.is_sale = is_sale;
        $scope.filter.is_rent = is_rent;
        $scope.filter.rent_price_from = [null, null];
        $scope.filter.sale_price_from = [null, null];
        $scope.filterChanged();
    };

    $scope.filterSearchAction = function (item) {
        // update filter from search
        if (item) {
            $scope.filter.geo_node_id = item.geo_node ? item.geo_node.id : null;
            $scope.filter.id = item.project_id ? item.project_id : null;
            if (item.geo_node) geoService.addCacheGeo(item.geo_node);
        } else {
            $scope.filter.geo_node_id = null;
            $scope.filter.id = null;
        }
        $scope.filterChanged();
    };

    $scope.filterSalePriceChanged = function () {
        let filter = $scope.filter;
        if (filter.sale_price[0] && filter.sale_price[1] && filter.sale_price[1] < filter.sale_price[0]) {
            filter.sale_price[1] = filter.sale_price[0];
        }
        filter.rent_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterRentPriceChanged = function () {
        let filter = $scope.filter;
        if (filter.rent_price[1] && filter.rent_price[0] && filter.rent_price[1] < filter.rent_price[0]) {
            filter.rent_price[1] = filter.rent_price[0];
        }
        filter.sale_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterChanged = function () {
        $scope.isFilterUpdated = true;
        let url = projectsFilterService.filterToUrl($scope.filter);
        router.navigate(url);
    };

    $scope.updateFilter = function (data, query) {
        return projectsFilterService.routeDataToFilter(data, query).then(function (filter) {
            $scope.filter = filter;
            return filter;
        });
    };

    $scope.loadProjects = function (append) {
        if (append) $scope.paginator.current += 1;
        let limit = $scope.paginator.size;
        let offset = ($scope.paginator.current - 1) * limit;
        projectService.getProjects($scope.filter, offset, limit, true).then(function (data) {
             // if append and $scope.projects - coz properties can be null append on html
            let projects = append && $scope.projects ? $scope.projects.concat(data.projects) : data.projects;
            $scope.projects = projects;
            $scope.paginator.count = data.count;
            $rootScope.page = data.page;

            //hide html properties after properties loaded
            if ($scope.displayProjectsHtml && !append) $scope.displayProjectsHtml = false;
            if (!append){
                $document.scrollTop(0, 500);
            }
        })
    };

    $scope.navigate = function (url) {
        if (url) {
            router.navigate(url)
        }
    };

    function applyRoute(query) {
        if (!$scope.filter) return;

        // update paginator before update projects
        $scope.paginator.url = projectsFilterService.filterToUrl($scope.filter);
        $scope.paginator.current = query['p'] ? parseInt(query['p']) : 1;

        // on first loading use backend rendered projects
        if (!$scope.isInitialState) {
            $scope.loadProjects();
        } else {
            $scope.isInitialState = false;
        }

        $scope.isFilterUpdated = false;
    }

    router.subscribe("/:action_type/", function (data, params, query) {
        if ($scope.isFilterUpdated) {
            applyRoute(query);
            return;
        }
        $scope.updateFilter(data, query).then(function () {
            applyRoute(query);
        });
    });

    router.init();
}]);
